import React, {useState} from 'react';
import { motion, AnimatePresence } from 'framer-motion'
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import CardHeader from '@mui/material/CardHeader';
import { useTheme } from '@mui/material/styles';
import ConfettiExplosion from 'react-confetti-explosion';
import Box from '@mui/material/Box';
import { useSnapshot } from "valtio"

const explosionSource = {
    position: 'absolute',
    right: '50%',
    left: '50%',
};
const littleExplodeProps = {
    force: 0.25,
    duration: 2000,
    particleCount: 100,
    particleSize: 7,
    height: 2000,
    width: 1000
};

const SquishButton = ({ sx = {}, onClick, withExplosion=false, children, ...props }) => {
    const [isExploding, setIsExploding] = useState(false);
    
    return <Button {...props}
        sx={{
            m: .5,
            ...sx,
        }}
        component={motion.div}
        whileHover={{
            scale: 1.2,
            transition: { duration: 0.3 }
        }}
        whileTap={{ scale: 0.9 }}
        onClick={(e) => {
            if(withExplosion){
                setIsExploding(true)
                setTimeout(()=>{
                    setIsExploding(false)
                }, 1500);
            }
            if (onClick){ 
                onClick()
            }
        }}
    >
        {children}
        {isExploding ? (
          <div style={explosionSource} hidden={!isExploding}>
            <ConfettiExplosion {...littleExplodeProps} />
          </div>
        ): null}
    </Button>
}
const SquishIconButton = ({ sx = {}, children, ...props }) => {
    return <IconButton {...props}
        sx={{
            m: .5,
            ...sx,
        }}
        component={motion.div}
        whileHover={{
            scale: 1.2,
            transition: { duration: 0.3 }
        }}
        whileTap={{ scale: 0.9 }}
    >{children}</IconButton>
}

const SquishIcon = ({ icon }) => {
    return <motion.div
        whileHover={{
            scale: 1.2,
            transition: { duration: 0.3 }
        }}
        whileTap={{ scale: 0.9 }}
    >
        {icon}
    </motion.div>
}
const SquishAvatar = ({ sx = {}, ...props }) => {
    return <Avatar {...props}
        sx={{
            m: .5,
            ...sx,
        }}
        component={motion.div}
        whileHover={{
            scale: 1.2,
            transition: { duration: 0.3 }
        }}
        whileTap={{ scale: 0.9 }}
    />
}

const SquishCardHeader = ({ sx = {}, ...props }) => {
    return <CardHeader {...props}
        sx={{
            // m: .5,
            ...sx,
        }}
        component={motion.div}
        whileHover={{
            scale: 1.2,
            transition: { duration: 0.3 }
        }}
        whileTap={{ scale: 0.9 }}
    />
}

const SquishDiv = ({ sx = {}, ...props }) => {
    return <motion.div {...props}
        whileHover={{
            scale: 1.2,
            transition: { duration: 0.3 }
        }}
        whileTap={{ scale: 0.9 }}
    />
}
const SquishImg = ({ sx = {}, ...props }) => {
    return <motion.img {...props}
        whileHover={{
            scale: 1.2,
            transition: { duration: 0.3 }
        }}
        whileTap={{ scale: 0.9 }}
    />
}



const svgHeartAsString = ({ filled, theme }) => {
    const d = filled ? "M7.655 14.9159C7.65523 14.9161 7.65543 14.9162 8 14.25C8.34457 14.9162 8.34477 14.9161 8.34501 14.9159C8.12889 15.0277 7.87111 15.0277 7.655 14.9159ZM7.655 14.9159L8 14.25L8.34501 14.9159L8.34731 14.9147L8.35269 14.9119L8.37117 14.9022C8.38687 14.8939 8.40926 14.882 8.4379 14.8665C8.49516 14.8356 8.57746 14.7904 8.6812 14.7317C8.8886 14.6142 9.18229 14.442 9.53358 14.2199C10.2346 13.7767 11.1728 13.13 12.1147 12.3181C13.9554 10.7312 16 8.35031 16 5.5C16 2.83579 13.9142 1 11.75 1C10.2026 1 8.84711 1.80151 8 3.01995C7.15289 1.80151 5.79736 1 4.25 1C2.08579 1 0 2.83579 0 5.5C0 8.35031 2.04459 10.7312 3.8853 12.3181C4.82717 13.13 5.76538 13.7767 6.46642 14.2199C6.81771 14.442 7.1114 14.6142 7.3188 14.7317C7.42254 14.7904 7.50484 14.8356 7.5621 14.8665C7.59074 14.882 7.61313 14.8939 7.62883 14.9022L7.64731 14.9119L7.65269 14.9147L7.655 14.9159Z"
        : "M4.25 2.5C2.91421 2.5 1.5 3.66421 1.5 5.5C1.5 7.64969 3.08041 9.64375 4.8647 11.1819C5.73533 11.9325 6.60962 12.5358 7.26796 12.952C7.56407 13.1392 7.81492 13.2875 8 13.3934C8.18508 13.2875 8.43593 13.1392 8.73204 12.952C9.39039 12.5358 10.2647 11.9325 11.1353 11.1819C12.9196 9.64375 14.5 7.64969 14.5 5.5C14.5 3.66421 13.0858 2.5 11.75 2.5C10.3768 2.5 9.14121 3.48581 8.72114 4.95604C8.62915 5.27802 8.33486 5.5 8 5.5C7.66514 5.5 7.37085 5.27802 7.27886 4.95604C6.85879 3.48581 5.62319 2.5 4.25 2.5ZM8 14.25C7.65543 14.9162 7.65523 14.9161 7.655 14.9159L7.65269 14.9147L7.64731 14.9119L7.62883 14.9022C7.61313 14.8939 7.59074 14.882 7.5621 14.8665C7.50484 14.8356 7.42254 14.7904 7.3188 14.7317C7.1114 14.6142 6.81771 14.442 6.46642 14.2199C5.76538 13.7767 4.82717 13.13 3.8853 12.3181C2.04459 10.7312 0 8.35031 0 5.5C0 2.83579 2.08579 1 4.25 1C5.79736 1 7.15289 1.80151 8 3.01995C8.84711 1.80151 10.2026 1 11.75 1C13.9142 1 16 2.83579 16 5.5C16 8.35031 13.9554 10.7312 12.1147 12.3181C11.1728 13.13 10.2346 13.7767 9.53358 14.2199C9.18229 14.442 8.8886 14.6142 8.6812 14.7317C8.57746 14.7904 8.49517 14.8356 8.4379 14.8665C8.40926 14.882 8.38687 14.8939 8.37117 14.9022L8.35269 14.9119L8.34731 14.9147L8.34501 14.9159C8.34477 14.9161 8.34457 14.9162 8 14.25ZM8 14.25L8.34501 14.9159C8.12889 15.0277 7.87111 15.0277 7.655 14.9159L8 14.25Z"
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="32" height="32"><path fill="${filled ? theme.palette.error.main : theme.palette.grey[50]}" fill-rule="evenodd" clip-rule="evenodd" d="${d}"></path></svg>`
}
const svgAsImgSrc = ({ filled, theme }) => {
    const svg = svgHeartAsString({ filled, theme })
    return `data:image/svg+xml;base64,${btoa(svg)}`
}

const MotionHeartIcon = ({ liked, sx = {}, ...props }) => {
    const theme = useTheme();
    // console.log("Theme:", theme)
    // const [hasClicked, setHasClicked] = React.useState(false)
    const size = { w: 18, h: 18 }

    const heart_variants = {
        hidden: {
            scale: 1,
        },
        notLiked: {
            scale: [1.4, .8, 1],
        },
        liked: {
            scale: [0, 1.5, 1],
            transition: { ease: [0.455, 0.03, 0.515, 0.955], duration: 0.35 }
        },
        // whileHover: {
        //     scale: 1.2,
        //     transition: { duration: 0.3 }
        // },
        // whileTap: { scale: 1.5 },
    }

    return <motion.div
        {...props}
        whileHover="whileHover"
        whileTap="whileTap"
        initial="notLiked"
        animate={liked ? "liked" : "notLiked"}
        variants={heart_variants}
        transition={{ duration: 0.5 }}
        style={{
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "2px"
        }}
    >
        <img src={svgAsImgSrc({ filled: liked, theme })} width={size.w} height={size.h} />
        {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 ${size.w / 2} ${size.h / 2}`}
            width={size.w}
            height={size.h}
        >
            {!hasClicked && (
                // https://primer.style/octicons-v2/heart-16
                <path
                    fill={theme.palette.grey[50]}
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 2.5C2.91421 2.5 1.5 3.66421 1.5 5.5C1.5 7.64969 3.08041 9.64375 4.8647 11.1819C5.73533 11.9325 6.60962 12.5358 7.26796 12.952C7.56407 13.1392 7.81492 13.2875 8 13.3934C8.18508 13.2875 8.43593 13.1392 8.73204 12.952C9.39039 12.5358 10.2647 11.9325 11.1353 11.1819C12.9196 9.64375 14.5 7.64969 14.5 5.5C14.5 3.66421 13.0858 2.5 11.75 2.5C10.3768 2.5 9.14121 3.48581 8.72114 4.95604C8.62915 5.27802 8.33486 5.5 8 5.5C7.66514 5.5 7.37085 5.27802 7.27886 4.95604C6.85879 3.48581 5.62319 2.5 4.25 2.5ZM8 14.25C7.65543 14.9162 7.65523 14.9161 7.655 14.9159L7.65269 14.9147L7.64731 14.9119L7.62883 14.9022C7.61313 14.8939 7.59074 14.882 7.5621 14.8665C7.50484 14.8356 7.42254 14.7904 7.3188 14.7317C7.1114 14.6142 6.81771 14.442 6.46642 14.2199C5.76538 13.7767 4.82717 13.13 3.8853 12.3181C2.04459 10.7312 0 8.35031 0 5.5C0 2.83579 2.08579 1 4.25 1C5.79736 1 7.15289 1.80151 8 3.01995C8.84711 1.80151 10.2026 1 11.75 1C13.9142 1 16 2.83579 16 5.5C16 8.35031 13.9554 10.7312 12.1147 12.3181C11.1728 13.13 10.2346 13.7767 9.53358 14.2199C9.18229 14.442 8.8886 14.6142 8.6812 14.7317C8.57746 14.7904 8.49517 14.8356 8.4379 14.8665C8.40926 14.882 8.38687 14.8939 8.37117 14.9022L8.35269 14.9119L8.34731 14.9147L8.34501 14.9159C8.34477 14.9161 8.34457 14.9162 8 14.25ZM8 14.25L8.34501 14.9159C8.12889 15.0277 7.87111 15.0277 7.655 14.9159L8 14.25Z"
                />
            )}
            {hasClicked && (
                // https://primer.style/octicons-v2/heart-fill-16
                <path
                    fill={theme.palette.error.main}
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.655 14.9159C7.65523 14.9161 7.65543 14.9162 8 14.25C8.34457 14.9162 8.34477 14.9161 8.34501 14.9159C8.12889 15.0277 7.87111 15.0277 7.655 14.9159ZM7.655 14.9159L8 14.25L8.34501 14.9159L8.34731 14.9147L8.35269 14.9119L8.37117 14.9022C8.38687 14.8939 8.40926 14.882 8.4379 14.8665C8.49516 14.8356 8.57746 14.7904 8.6812 14.7317C8.8886 14.6142 9.18229 14.442 9.53358 14.2199C10.2346 13.7767 11.1728 13.13 12.1147 12.3181C13.9554 10.7312 16 8.35031 16 5.5C16 2.83579 13.9142 1 11.75 1C10.2026 1 8.84711 1.80151 8 3.01995C7.15289 1.80151 5.79736 1 4.25 1C2.08579 1 0 2.83579 0 5.5C0 8.35031 2.04459 10.7312 3.8853 12.3181C4.82717 13.13 5.76538 13.7767 6.46642 14.2199C6.81771 14.442 7.1114 14.6142 7.3188 14.7317C7.42254 14.7904 7.50484 14.8356 7.5621 14.8665C7.59074 14.882 7.61313 14.8939 7.62883 14.9022L7.64731 14.9119L7.65269 14.9147L7.655 14.9159Z"
                />
            )}
        </svg> */}
    </motion.div>
}

// Word wrapper
const Wrapper = (props) => {
    // We'll do this to prevent wrapping of words using CSS
    return <AnimatePresence><span
        className="word-wrapper"
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            whiteSpace: "nowrap",
            ...(props.sx || {})
        }}
        {...props}
    >{props.children}</span></AnimatePresence>
};


const TextLoop = ({ texts, prefix = "", color = null, leadMargin = 8, sx = {}, nextWordMs = 1500, spanSx = {} }) => {
    const [index, setIndex] = React.useState(0);
    const theme = useTheme()
    const textColor = color ?? theme.palette.primary.main;
    // Framer Motion variant object, for controlling animation
    const item = {
        initial: {
            y: "-400%",
            // color: "#0055FF",
            color: textColor,//"#0055FF",
            opacity: 0,
            transition: { ease: [0.455, 0.03, 0.515, 0.955], duration: 0.25 }
        },
        animate: {
            y: "0%",
            color: textColor,
            opacity: 1,
            transition: { ease: [0.455, 0.03, 0.515, 0.955], duration: 0.35 }
        },
        exit: {
            y: "400%",
            opacity: 0,
            color: textColor,//"#0055FF",
            transition: { ease: [0.455, 0.03, 0.515, 0.955], duration: 0.2 }
        }
    };


    React.useEffect(() => {
        setTimeout(() => {
            let next = index + 1;
            setIndex(next % texts.length);
        }, nextWordMs);
    }, [index, setIndex, texts]);

    const container = {
        visible: {
            transition: {
                staggerChildren: 0.025
            }
        }
    };

    return (
        <motion.div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                ...sx
            }}
        // variants={container}
        // initial="hidden"
        // animate="visible"
        >
            {prefix ?? prefix + " "}
            <span style={{
                display: "flex",
                overflow: "hidden",
                margin: `${leadMargin}px`,
                // border: "1px solid white",
                // textDecoration: "underline",
                ...spanSx
            }} >

                <AnimatePresence sync>
                    <motion.span
                        key={"animate_" + index}
                        style={{ display: "inline-block" }}//, border: "1px solid red"}}
                        // variants={item}
                        initial={item.initial}
                        animate={item.animate}
                        exit={item.exit}
                    // exit={{ opacity: 0 }}
                    // initial="animate"
                    // animate="hidden"
                    >
                        {texts[index]}
                    </motion.span>
                </AnimatePresence>
            </span>
        </motion.div >
        // <Box display="inline" position="relative" w="100%" sx={{ ...sx }}>
        //     <AnimatePresence initial={false}>
        //         <motion.span
        //             position="absolute"
        //             key={index}
        //             layout
        //             variants={{
        //                 enter: {
        //                     translateY: 20,
        //                     opacity: 0,
        //                     height: 0
        //                 },
        //                 center: {
        //                     zIndex: 1,
        //                     translateY: 0,
        //                     opacity: 1,
        //                     height: "auto"
        //                 },
        //                 exit: {
        //                     zIndex: 0,
        //                     translateY: -20,
        //                     opacity: 0,
        //                     height: 0
        //                 }
        //             }}
        //             initial="enter"
        //             animate="center"
        //             exit="exit"
        //             transition={{
        //                 translateY: { type: "spring", stiffness: 300, damping: 200 },
        //                 opacity: { duration: 0.5 }
        //             }}
        //         >
        //             {texts[index]}
        //         </motion.span>
        //     </AnimatePresence>
        // </Box>
    );
};

export {
    SquishButton,
    SquishIconButton,
    SquishIcon,
    SquishAvatar,
    SquishCardHeader,
    SquishDiv,
    SquishImg,
    MotionHeartIcon,
    TextLoop
}